


























































































































import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  Ref,
  onBeforeUnmount,
} from '@nuxtjs/composition-api'
import { useSidebar, Sidebars } from '~/composables/ui/useSidebar'
import debounce from 'lodash.debounce'
import { useEventListener } from '~/composables/ui/useEventListener'
import { useElementSize } from '~/composables/ui/useElementSize'
import BaseIcon from "~/components/base/Icon.vue";
import { useAuth } from '~/composables/useAuth'
import { useBreakpoint } from '~/composables/ui/useBreakpoint'
import { useSiteBanner } from '~/composables/useSiteBanner'

export default defineComponent({
  name: 'AppHeader',
  components: {BaseIcon},
  setup() {
    const headerInnerEl = ref<HTMLElement | null>(null)
    const headerHeight = ref(0)
    const headerInnerPosition = ref('relative')
    const getHeaderHeight = () => {
      headerHeight.value =
        headerInnerEl.value?.getBoundingClientRect().height || 0
    }
    const scrollTop = ref(0)
    const onScroll = () => {
      scrollTop.value =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
    }
    const { user } = useAuth()
    if (process.client) {
      useEventListener(window, 'scroll', onScroll)
    }
    const scrolled = computed(() => scrollTop.value > 66)


    const onElementSizeChange = () => {
      getHeaderHeight()
    }

    const timer: Ref<ReturnType<typeof setTimeout> | null> = ref(null)
    const isMounted = ref(false)
    onMounted(() => {
      if (headerInnerEl.value) {
        useElementSize(headerInnerEl.value, debounce(onElementSizeChange, 500))
        timer.value = setTimeout(() => {
          isMounted.value = true
          headerInnerPosition.value = 'fixed'
        }, 100)
      }
    })

    onBeforeUnmount(() => {
      if (timer.value) {
        clearTimeout(timer.value)
      }
    })
    const sidebar = useSidebar()
    const openMenu = () => {
      sidebar.go(Sidebars.AppSidebarMenu,{accountFlag: true})
    }

    const diffHeight = ref(0)
    watch(headerHeight, (newVal, oldVal) => {
      if (scrolled.value) {
        diffHeight.value = oldVal - newVal
      } else {
        diffHeight.value = 0
      }
    })
    const { filteredSiteBanners } = useSiteBanner()
    const isEmptySiteBanner = computed(() => !filteredSiteBanners.value?.length)
    
    // const { isMobile } = useBreakpoint()
    // const calcHeaderHeight = computed(() => {
    //   if (isMobile.value) {
    //     return headerHeight.value
    //   } else {
    //     return isEmptySiteBanner.value
    //       ? headerHeight.value
    //       : headerHeight.value + 24
    //   }
    // })
    return {
      headerInnerEl,
      isMounted,
      headerInnerPosition,
      headerHeight,
      scrolled,
      diffHeight,
      openMenu,
      user,
      isEmptySiteBanner
    }
  },

})
